import { dispatch } from "hf-rt";
import { HOST_URL } from "../constants";

const initialState = {
  recommendProductsInsider: []
};

export default {
  name: "recommendation",
  actions: {
    updateRecommendationInsider: data =>
      dispatch({ type: "UPDATE_RECOMMENDATION_INSIDER", data }),
    fetchRecommendation: async function (cbu) {
      dispatch({ type: "FETCH_RECOMMENDATION" });
      try {
        const url = `${HOST_URL}/shopping/v1/compositions/recommendations/insider/channelCatalogItems?channelCatalogItemCode=${cbu}`;
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          },
          credentials: "include"
        });
        if (response.ok) {
          const data = await response.json();
          this.updateRecommendationInsider(data);
        } else {
          window.logApiErrors(
            "r",
            "fetchRecommendation",
            response.status,
            response.statusText
          );
          throw new Error(response.status);
        }
      } catch (error) {
        console.error(error);
      } finally {
      }
    }
  },
  reducers: function (state = initialState, action) {
    switch (action.type) {
      case "UPDATE_RECOMMENDATION_INSIDER":
        return {
          ...state,
          recommendProductsInsider: action.data
        };

      default:
        return state;
    }
  }
};
